'use strict';
/*istanbul ignore next*/
function controller (sellerService, modalService, pageStateService) {
    const ctrl = this;
    let isModalActionSet = false;

    ctrl.$onInit = () => {
        sellerService.getSeller().then((sellerResponse) => {
            ctrl.seller = sellerResponse.data.sellerDto;
        });
    };

    ctrl.setupTYModalPageData = function() {
        if (!isModalActionSet) {
            setModalActions({
                afterOpen: () => {
                    if (pageStateService.get('page.pageInfo.pageName')[1] !== 'leads/emailLeadThanks_VDP') {
                        pageStateService.push('page.pageInfo.pageName', 'leads/emailLeadThanks_VDP', false);
                    }
                   if (pageStateService.get('page.pageInfo.channel')[1] !== 'leads') {
                        pageStateService.push('page.pageInfo.channel', 'leads', false);
                    }
                },
                afterClose: () => {
                    /* istanbul ignore next */
                    const fullPageNameStack = (pageStateService.get('page.pageInfo.pageName')[0] !== 'leads/emailLeadThanks_VDP')
                                                && (pageStateService.get('page.pageInfo.pageName')[1] === 'leads/emailLeadThanks_VDP');
                    const fullChannelStack = (pageStateService.get('page.pageInfo.channel')[0] !== 'leads')
                                                && (pageStateService.get('page.pageInfo.channel')[1] === 'leads');
                    if (fullPageNameStack) {
                        pageStateService.pop('page.pageInfo.pageName', false);
                    }
                    if (fullChannelStack) {
                        pageStateService.pop('page.pageInfo.channel', false);
                    }
                }
            });
            isModalActionSet = true;
        }
    };

    function setModalActions(options) {
        let modal = modalService.get('typModal');
        modal.afterOpen(options.afterOpen);
        modal.afterClose(options.afterClose);
    }
}

controller.$inject = ['sellerService', 'modalService', 'pageStateService'];

export default controller;
